
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/passenger-car",
      function () {
        return require("private-next-pages/wheels/passenger-car.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/passenger-car"])
      });
    }
  